import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/preventive-maintenance')({
  component: PreventiveMaintenanceLayout,
});

function PreventiveMaintenanceLayout() {
  return <Outlet />;
}
